import { useState, useEffect, useRef } from 'react'
import type { animate } from 'motion'

export function useAnimationProgress(
  animationRef: React.RefObject<ReturnType<typeof animate> | null>,
  isPlaying: boolean
): number {
  const [progress, setProgress] = useState(0)
  const rafRef = useRef<number>(0)

  useEffect(() => {
    if (!isPlaying) {
      setProgress(0)
      return
    }

    const tick = () => {
      const anim = animationRef.current
      if (anim && anim.duration > 0) {
        const p = Math.min(anim.time / anim.duration, 1)
        setProgress(p)
      }
      rafRef.current = requestAnimationFrame(tick)
    }

    rafRef.current = requestAnimationFrame(tick)

    return () => {
      cancelAnimationFrame(rafRef.current)
    }
  }, [isPlaying, animationRef])

  return progress
}
